module.exports = __webpack_public_path__ + "img/lh1.8cb55d1c.jpg";